import { configurationLookup } from "../lib/cachedLookups";
import { ConfigurationId } from "../types/Lookups";
import useLookup from "./useLookup";

/** One system setting (see `ConfigurationId`), or undefined while it loads or if it failed. */
export const useConfiguration = (id: ConfigurationId): string | undefined =>
	useLookup(configurationLookup(id)).data;

/** A numeric system setting, such as a length or the country id. */
export const useConfigurationNumber = (
	id: ConfigurationId
): number | undefined => {
	const value = useConfiguration(id);
	const number = Number(value);
	return value === undefined || Number.isNaN(number) ? undefined : number;
};
